import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/18_card_back_sunflowers/18_card_back_sunflowers"
 * Contains 1 texture(s)
 */
export class CardsBacks18CardBackSunflowersAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/18_card_back_sunflowers/18_card_back_sunflowers';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '18_sunflowers.png'
    ] as const;
}
